import { Pipe, PipeTransform, inject } from '@angular/core';
import { PublicMultimediaDataSourceService } from '../services/public-multimedia-data-source.service';
import { Guid } from '@web/utils';

@Pipe({
  name: 'publicShopFilePreviewUrl',
})
export class PublicShopFilePreviewUrlPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly multimediaDataSource = inject(PublicMultimediaDataSourceService);

  public transform(id: Guid): string {
    return this.multimediaDataSource.shopFilePreviewUrl(id);
  }
}
